module.exports = __webpack_public_path__ + "explore/Components/ExploreHeader/magnifying-glass.babcb96d754c7553d075d4f444378595.svg";